module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("作业详情")]), _vm._v(" "), _c('divider', [_vm._v("课程信息")]), _vm._v(" "), _c('course-card', {
    attrs: {
      "course-instance": _vm.courseInstance
    }
  }), _vm._v(" "), _c('divider', [_vm._v("作业信息")]), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "题目",
      "border-intent": false
    }
  }, [_c('span', {
    staticClass: "homework-title"
  }, [_vm._v(_vm._s(_vm.title_display))])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "状态",
      "border-intent": false
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.t.trans(_vm.homework.status)))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOverdue),
      expression: "isOverdue"
    }],
    staticClass: "warning"
  }, [_vm._v("(逾期)")])])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "布置日期",
      "border-intent": false
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.createDate))])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "要求交作业日期",
      "border-intent": false
    }
  }, [_c('due-day', {
    attrs: {
      "date": !_vm.homework ? _vm.homework : _vm.homework.due_date
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "详细要求",
      "is-link": true,
      "border-intent": false,
      "arrow-direction": _vm.showAssignment ? 'down' : 'right'
    },
    nativeOn: {
      "click": function($event) {
        _vm.showAssignment = !_vm.showAssignment
      }
    }
  }), _vm._v(" "), (_vm.showAssignment) ? [_c('div', {
    staticClass: "cell-details"
  }, [_c('p', {
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v(_vm._s(_vm.homework.title))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.homework.assignment)
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.hasAttachment) ? _c('cell', {
    attrs: {
      "is-link": true,
      "link": _vm.attachmentLink,
      "border-intent": false
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px",
      "padding-top": "3px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/attachment.svg"),
      "width": "18px"
    }
  })]), _vm._v(_vm._s(_vm.homework.attachment_name))])]) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "评分/评语",
      "is-link": _vm.hasComments,
      "border-intent": false,
      "arrow-direction": _vm.showComments ? 'down' : 'right'
    },
    nativeOn: {
      "click": function($event) {
        _vm.hasComments ? _vm.showComments = !_vm.showComments : ''
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.homework.score || '--') + "  ")])]), _vm._v(" "), (_vm.showComments) ? [_c('div', {
    staticClass: "cell-details"
  }, [_c('p', [_vm._v(_vm._s(_vm.homework.comments))])])] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28beb0b2"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Homework.vue
// module id = 546
// module chunks = 1